"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var angular = require("angular");
var table_chart_component_1 = require("../../../components/table-chart/table-chart.component");
var basic_table_component_1 = require("../basic-component/basic-table.component");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var simple_table_logic_1 = require("./simple-table.logic");
var COMPONENT_NAME = 'smartorg.r6.acts.simpleTable';
function triggerResize() {
    $(window).trigger('resize');
}
var SimpleTableComponent = /** @class */ (function () {
    function SimpleTableComponent($scope, $timeout) {
        this.displayOptions = { CHART: 'CHART', TABLE: 'TABLE' };
        this.chartByOptions = table_chart_component_1.chartOptions.chartBy;
        var ctrl = this;
        this.$timeout = $timeout;
        this.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('workbench:toggle-collapse:right', function () { return $timeout(triggerResize); });
        $scope.$on('workbench:toggle-collapse:left', function () { return $timeout(triggerResize); });
        $scope.$on('command:TABLE', function (event, args) {
            ctrl.gridOptions = null;
            $timeout(function () {
                $scope.$apply();
                ctrl.initTable(args);
            });
        });
    }
    SimpleTableComponent.prototype.getInputObj = function (node, inputData) {
        if (!node || !inputData) {
            return null;
        }
        return { nodeName: node.name, nodePath: node.getBreadcrumb(), table: inputData };
    };
    SimpleTableComponent.prototype.initTable = function (args) {
        var treeName = args.treeName, actionMenuItem = args.actionMenuItem, node = args.node, compareToNode = args.compareToNode, data = args.config.data;
        var _a = data.config, pnl = _a.pnl, specialRules = _a.specialRules, displayRules = _a.displayRules, inputData = data.inputData, shadowInputData = data.shadowInputData, settings = data.settings, chartSettings = data.chartSettings;
        var timestamp = node.lastRecalc;
        this.actionMenuItem = actionMenuItem;
        this.title = actionMenuItem + " for " + inputData.tableName;
        this.display = this.displayOptions.TABLE;
        var tableConfig = {
            treeName: treeName, actionMenuItem: actionMenuItem, specialRules: specialRules, displayRules: displayRules, timestamp: timestamp,
            isPnl: pnl,
            tableSettings: basic_table_component_1.loadSettings(treeName, settings)
        };
        this.tableObject = new simple_table_logic_1["default"](this.getInputObj(node, inputData), this.getInputObj(compareToNode, shadowInputData), tableConfig);
        var chartAsDefaultConfig = settings.setChartAsDefault ? settings.setChartAsDefault.table : null;
        var chartDefault = this.getDefaultDisplay(chartAsDefaultConfig);
        this.chartConfig = {
            chartSettings: basic_chart_component_1.loadSettings(treeName, chartSettings),
            defaultDisplay: chartDefault,
            ignoredCols: this.getIgnoredColInChart(displayRules),
            isPnl: pnl,
            timestamp: timestamp
        };
        if (chartDefault) {
            this.display = this.displayOptions.CHART;
            this.chartBy = chartDefault.chartBy;
        }
        this.gridOptions = this.tableObject.getGridOptions();
        this.processPrivilegeAndMenu(node._id);
        this.$timeout();
    };
    SimpleTableComponent.prototype.getIgnoredColInChart = function (displayRules) {
        if (!displayRules) {
            return [];
        }
        var rules = displayRules.filter(function (rule) { return rule.RULE === 'IGNORE_COL_IN_CHARTS'; }).map(function (rule) { return rule.ColHeader; });
        var result = [];
        rules.forEach(function (r) {
            if (r instanceof Array) {
                r.forEach(function (x) { return result.push(x); });
            }
            else {
                result.push(r);
            }
        });
        return result;
    };
    SimpleTableComponent.prototype.getDefaultDisplay = function (chartAsDefault) {
        var _this = this;
        var _a = chartAsDefault || { row: null, col: null }, row = _a.row, col = _a.col;
        if (!row && !col) {
            return;
        }
        var chartByRowConfig = row.find(function (x) { return x.chartId === _this.actionMenuItem; });
        var chartByColConfig = col.find(function (x) { return x.chartId === _this.actionMenuItem; });
        if (chartByRowConfig) {
            chartByRowConfig.chartBy = this.chartByOptions.ROW;
        }
        else if (chartByColConfig) {
            chartByColConfig.chartBy = this.chartByOptions.COL;
        }
        return chartByRowConfig || chartByColConfig;
    };
    SimpleTableComponent.prototype.processPrivilegeAndMenu = function (nodeId) {
        var _this = this;
        this.smartorgApi.getUserPrivilege(nodeId).then(function (privilege) {
            _this.userIsPortfolioAdmin = (privilege >= 3);
            _this.setMenu(_this.userIsPortfolioAdmin);
        })["catch"](function (err) {
            _this.showAlert('warning', 'Failed to load user privilege', err);
            _this.setMenu(false);
        });
    };
    SimpleTableComponent.prototype.showTable = function () {
        this.display = this.displayOptions.TABLE;
        this.setMenu(this.userIsPortfolioAdmin);
    };
    SimpleTableComponent.prototype.chartByRow = function () {
        this.chartBy = 'row';
        this.display = this.displayOptions.CHART;
        this.setMenu(this.userIsPortfolioAdmin);
    };
    SimpleTableComponent.prototype.chartByCol = function () {
        this.chartBy = 'col';
        this.display = this.displayOptions.CHART;
        this.setMenu(this.userIsPortfolioAdmin);
    };
    SimpleTableComponent.prototype.updateDefaultDisplay = function (newConfig) {
        console.log('Update Default', newConfig);
        this.newDefaultDisplay = __assign({}, newConfig);
    };
    SimpleTableComponent.prototype.setDefaultDisplay = function () {
        var _this = this;
        var defaultDisplay = this.newDefaultDisplay || this.chartConfig.defaultDisplay;
        if (!defaultDisplay) {
            if (this.display === this.displayOptions.CHART) {
                this.showAlert('danger', 'Error!', 'Cannot read default display info!');
                return;
            }
        }
        var _a = (defaultDisplay || {}), chartBy = _a.chartBy, chartType = _a.chartType, orientation = _a.orientation;
        var _b = this.tableObject.tableConfig, treeName = _b.treeName, actionMenuItem = _b.actionMenuItem;
        var c = this.display === this.displayOptions.TABLE ? 'table' : chartBy;
        this.smartorgApi.setChartAsDefault(treeName, actionMenuItem, 'table', c, chartType || null, orientation || null, null).then(function (res) {
            _this.showAlert('success', 'Setting Saved!', 'Default display set successfully.');
        })["catch"](function (err) {
            _this.showAlert('danger', 'Error!', err.message);
        });
    };
    SimpleTableComponent.prototype.exportCharts = function () {
        var exporter = new smartorg.r6.lib.ChartExporter('chart', 'svg-canvas');
        exporter.exportChart(this.title, true);
    };
    SimpleTableComponent.prototype.exportTable = function (format) {
        if (format === void 0) { format = null; }
        var csv = this.tableObject.getCsv(format);
        var namePrefix = this.title || 'Table';
        if (format) {
            namePrefix += "(" + format + ")";
        }
        var extraRow = "\"" + this.title + "\"\n";
        Common.downloadCSV(extraRow + csv, namePrefix + '_');
    };
    SimpleTableComponent.prototype.setMenu = function (isPortfolioAdmin) {
        var ctrl = this;
        var displayItems = [];
        var exportItems = [];
        if (this.display !== this.displayOptions.TABLE) {
            displayItems.push({
                name: 'Table',
                callback: function () { return ctrl.showTable(); }
            });
        }
        if (this.display === this.displayOptions.TABLE || this.chartBy !== this.chartByOptions.ROW) {
            displayItems.push({
                name: 'Chart by Row',
                callback: function () { return ctrl.chartByRow(); }
            });
        }
        if (this.display === this.displayOptions.TABLE || this.chartBy !== this.chartByOptions.COL) {
            displayItems.push({
                name: 'Chart by Column',
                callback: function () { return ctrl.chartByCol(); }
            });
        }
        if (isPortfolioAdmin) {
            displayItems.push({
                name: 'Set as Default',
                callback: function () { return ctrl.setDefaultDisplay(); }
            });
        }
        if (this.display === this.displayOptions.CHART) {
            exportItems.push({
                name: 'Chart',
                callback: function () { return ctrl.exportCharts(); }
            });
        }
        else {
            exportItems.push({
                name: 'Table',
                callback: function () { return ctrl.exportTable(); }
            });
            exportItems.push({
                name: 'Table EU',
                callback: function () { return ctrl.exportTable('EU'); }
            });
        }
        this.menu = [
            { name: 'Display', items: displayItems },
            { name: 'Export', items: exportItems },
        ];
        this.$timeout();
    };
    return SimpleTableComponent;
}());
angular.module(COMPONENT_NAME, [
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.moveColumns',
    'ui.grid.grouping',
    table_chart_component_1["default"],
]).component('simpleTable', {
    template: require('./simple-table.component.html'),
    bindings: {
        smartorgApi: '=?',
        menu: '='
    },
    controller: SimpleTableComponent
}).filter('tableNumber', function () {
    return function (val, fractionSize) {
        if (typeof val === 'undefined' || val === null || val.toString().trim() === '' || isNaN(val)) {
            return val;
        }
        return parseFloat(val).toFixed(fractionSize);
    };
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=simple-table.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/simple-table/simple-table.component.js